// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"638":"6fd83f095b205814","2335":"2a3ce8c6da648e33","6894":"a4a1bedb9ce09116","7835":"1cbcd38dfcf3e088","8390":"b41a80fe8963e311"}[chunkId] + ".js";
};